import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
    fetchSingleRecord
} from './changelog-versions.action';
import { ChangelogVersion } from './changelog-versions.model';

export interface ChangelogVersionsRecordsState {
    listData: ChangelogVersion[];
    singleData: ChangelogVersion;
    loading: boolean;
    error: any;
}

export const initialState: ChangelogVersionsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
};


export const changelogVersionsRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData }) => {
        return { ...state, listData: listData, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);